<template>
  <div class="page-error">
    <div class="page-error-img" :class="{ 'img-404': error == 404, 'img-500': error != 404 }"></div>

    <div class="page-error-text">
      <div v-if="error == 404">
        <span>{{ $t('general.labels.error') }} 404</span>
        <h1>{{ $t('error.oops') }},</h1>
        <h2>{{ $t('error.page_not_exists') }}</h2>
        <p>{{ $t('error.check_url') }}</p>
      </div>
      <div v-else>
        <span>{{ $t('general.labels.error') }}</span>
        <h1>{{ $t('error.oops') }},</h1>
        <h2>{{ $t('error.something_wrong') }}</h2>
        <p>{{ $t('error.system_offline') }}{{ $t('error.our_devs') }}{{ $t('error.try_again_later') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'error',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** ErrorPage.vue?34006841
 **/